export default function* root() {}
